import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * The sprite itself, placed once in the shell. Every `portal-icon` references a symbol out of it
 * through `<use>`, so the icons cost no requests and no runtime loading.
 *
 * The template is generated -- see `tools/build-icon-sprite.mjs`, run through `yarn icons`.
 */
@Component({
  selector: 'portal-icon-sprite',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './icon-sprite.html',
  styles: `
    :host {
      display: none;
    }
  `
})
export class IconSprite {}